import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { Button, Stack, Typography } from '@mui/material'
import { INTEGRATION_TYPE } from '@/config'
import './integration.scss'

interface IntegrationCardProps {
  logo: string
  name: string
  description: string
  type: string
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  logo,
  name,
  description,
  type,
}) => {
  const { t } = useTranslation('translation')
  const history = useHistory()

  const handleClick = () => {
    history.push(INTEGRATION_TYPE.replace(':type', type))
  }

  return (
    <Stack
      gap={2}
      onClick={handleClick}
      justifyContent="space-between"
      className="tw-relative tw-border tw-rounded-lg tw-px-4 xl:tw-px-6 tw-pt-6 tw-pb-4 tw-cursor-pointer tw-shadow-md hover:tw-shadow-xl"
    >
      <Stack gap={2}>
        <div className="tw-flex tw-items-center tw-justify-center tw-h-20 tw-p-2">
          <img
            src={logo}
            alt={name}
            className="tw-max-h-full tw-max-w-full tw-object-contain"
          />
        </div>

        <Typography
          variant="subtitle2"
          component="h5"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: '2',
            WebkitBoxOrient: 'vertical',
          }}
        >
          {name}
        </Typography>

        <Typography
          variant="body3"
          color="textGrey"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: '3',
            WebkitBoxOrient: 'vertical',
          }}
        >
          {description}
        </Typography>
      </Stack>

      <Stack
        sx={{
          borderTop: '1px solid #E5E7EB',
        }}
        pt={2}
      >
        <Button
          variant="outlined"
          fullWidth
          onClick={handleClick}
          sx={{
            '&:hover': {
              backgroundColor: 'primary.main',
              color: 'white',
              borderColor: 'primary.main',
            },
          }}
        >
          {t('Configure')}
        </Button>
      </Stack>
    </Stack>
  )
}

export default IntegrationCard
